/**
 * URL sanitizer for blog directives. Allowlist of schemes; whitespace, control
 * and zero-width characters are removed before the scheme check, because
 * browsers ignore them inside a scheme ("java<TAB>script:").
 */
const SAFE_SCHEMES = new Set(["http", "https", "mailto", "tel"])

const IGNORED_RANGES: ReadonlyArray<readonly [number, number]> = [
  [0x0000, 0x0020],
  [0x007f, 0x00a0],
  [0x00ad, 0x00ad],
  [0x061c, 0x061c],
  [0x1680, 0x1680],
  [0x180e, 0x180e],
  [0x2000, 0x200f],
  [0x2028, 0x202f],
  [0x205f, 0x206f],
  [0x3000, 0x3000],
  [0xfeff, 0xfeff],
]

function isIgnored(ch: string): boolean {
  const code = ch.charCodeAt(0)
  return IGNORED_RANGES.some(([lo, hi]) => code >= lo && code <= hi)
}

function stripIgnored(value: string): string {
  return Array.from(value).filter((ch) => !isIgnored(ch)).join("")
}

export function sanitizeHref(href: string): string {
  const compact = stripIgnored(href).toLowerCase()
  const scheme = /^([a-z][a-z0-9+.-]*):/.exec(compact)
  if (scheme && !SAFE_SCHEMES.has(scheme[1])) return "#"
  return href
}
